import { BookableOccurrenceResponse } from "../contracts/BookableOccurrenceResponse";
import { OccurrenceSeatResponse } from "../contracts/OccurrenceSeatResponse";

/**
 * The bookable list after a successful booking: the booked occurrence carries the new
 * seat status and one place fewer (unlimited stays unlimited).
 */
export const applyBookedSeat = (
  occurrences: BookableOccurrenceResponse[],
  seat: OccurrenceSeatResponse,
): BookableOccurrenceResponse[] =>
  occurrences.map((occurrence) =>
    occurrence.bookingId === seat.bookingId && occurrence.date === seat.occurrenceDate
      ? {
          ...occurrence,
          seatStatus: seat.status,
          placesLeft:
            occurrence.placesLeft === null ? null : Math.max(0, occurrence.placesLeft - 1),
        }
      : occurrence,
  );
